function prepareFormDataFromKeyArray (data, keyArray) {
  const formData = {}

  for (const key of keyArray) {
    if (key in data) {
      formData[key] = data[key]
    }
  }

  return formData
}

export {
  prepareFormDataFromKeyArray
}
